<div class="client-item-container"
     fxLayout="row"
     fxLayoutAlign="start center">
  
  <!-- Patient Avatar -->
  <div class="patient-avatar">
    <mat-icon>account_circle</mat-icon>
  </div>

  <!-- Main Content -->
  <div class="patient-content"
       fxFlex>
    
    <!-- Header Row: Name + Notifications -->
    <div class="patient-header">
      <span class="patient-name">
        {{ (client.firstname || client.lastname) 
            ? (client.firstname || '') + (client.firstname && client.lastname ? ' ' : '') + (client.lastname || '')
            : (client.caseName || 'Unnamed patient') }}
      </span>
      <mat-icon *ngIf="hasNotifications" 
                class="notification-icon">
        notifications
      </mat-icon>
    </div>

    <!-- Patient Details -->
    <div class="patient-details">

      <!-- Row 1: Patient ID (truncates if long) -->
      <div class="patient-ids-info">
        <span class="ids-label">Patient ID:</span>
        <span *ngIf="currentFacilityPatientId"
              class="current-patient-id"
              [matTooltip]="currentFacilityPatientId"
              matTooltipPosition="above">
          {{currentFacilityPatientId}}
        </span>
        <span *ngIf="!currentFacilityPatientId" class="ids-none">N/A</span>
        <button *ngIf="hasMorePatientIds"
                class="more-ids-button"
                mat-icon-button
                matTooltip="View all Patient IDs"
                (click)="viewPatientIds($event)">
          <mat-icon>more_horiz</mat-icon>
        </button>
      </div>

      <!-- Row 2: DOB / Gender / Added — spread across full width -->
      <div class="patient-meta">
        <span *ngIf="client.dob && isValidDate(client.dob)" class="meta-item">
          DOB: {{ client.dob | date:'M/d/yyyy' }}
        </span>
        <span *ngIf="client.dob && !isValidDate(client.dob)" class="meta-item">
          DOB: {{ client.dob }}
        </span>
        <span *ngIf="client.gender" class="meta-item">Gender: {{ client.gender }}</span>
        <span *ngIf="client.createdAt" class="meta-item">Added: {{ client.createdAt | date:'M/d/yyyy' }}</span>
      </div>

    </div>
  </div>

  <!-- Edit Button -->
  <button *ngIf="!permissions.dialogdata && permissions.ableToEditClient"
          class="edit-client-button"
          mat-icon-button
          matTooltip="Edit Client"
          (click)="handleEditClient($event, client)">
    <mat-icon>create</mat-icon>
  </button>
</div>
